import { render, staticRenderFns } from "./Ariba.vue?vue&type=template&id=21a260a2"
import script from "./Ariba.vue?vue&type=script&lang=js"
export * from "./Ariba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports